/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import { Box, Container, Grid, Paper, Typography, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ExpandableCard } from './ExpandableCard';
import { LatLng, Layer } from '../../types';
import { LayerEditableMap, getCentroidOfMap } from './LayerEditableMap';
import { Copyright } from '../dashboard/Copyright';
import config from '../../config';
import { useAxios } from '../../services/axios';
import { useAuth } from '../../services/cognito';

export function Layer0() {
  const navigate = useNavigate();
  const { isAuthenticated, tokenReady, token, initialized } = useAuth();
  
  const { response, loading } = useAxios({
    baseURL: config.api.url,
    url: '/mdsouth/layers',
    method: 'GET',
  });

  const [parent, setParent] = React.useState<Layer>({} as Layer);
  const [layers, setLayers] = React.useState<Layer[]>([]);
  const [center, setCenter] = React.useState<LatLng>({
    lat: config.map.defaultCentroid.lat,
    lng: config.map.defaultCentroid.lng,
  });
  const [expandedStates, setExpandedStates] = React.useState(
    Object.assign({}, ...layers.map(x => ({ [x.id]: false }))),
  );

  const handleLayerClicked = (layer: Layer) => {
    navigate(`/map/${layer.name}`);
  };

  const handleExpandClick = (id: number) => () => {
    setExpandedStates((prev: any) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const handleCenterChanged = (center: LatLng) => {
    setCenter(center);
  };

  React.useEffect(() => {
    // set Layer data
    if (response !== undefined) {
      setParent(response?.data.parent);
      setLayers(response?.data.layers);
      setCenter(getCentroidOfMap(response?.data.layers));
    }
  }, [response]);

  // 모든 인증 조건이 만족되지 않으면 로딩 표시
  if (!initialized || !isAuthenticated || !tokenReady || !token) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // API 로딩 중이면 로딩 표시
  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: theme =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <Container
        disableGutters
        maxWidth="lg"
        sx={{ mt: 2, mb: 2, pl: 1, pr: 1 }}
      >
        <Grid container spacing={0.5}>
          {/* Map */}
          <Grid item xs={12}>
            <Typography
              component="h2"
              variant="h6"
              color="primary"
              gutterBottom
              sx={{ ml: 1 }}
            >
              서울목동남부
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Paper
              sx={{ p: 2, display: 'flex', flexDirection: 'column' }}
              style={{ padding: 25 }}
            >
              {/* Map<Orders /> */}
              <LayerEditableMap
                editable
                mapLevel={6}
                parent={parent}
                layerLevel={1}
                layers={layers}
                setLayers={setLayers}
                center={center}
                handleCenterChanged={handleCenterChanged}
                layerClicked={handleLayerClicked}
                apiEndpoint={`${config.api.url}/mdsouth/layers`}
              />
            </Paper>
          </Grid>
          {layers.map((layer: Layer) => (
            <Grid item xs={12} key={layer.id}>
              <ExpandableCard
                layer={layer}
                expand={expandedStates[layer.id]}
                onExpandClick={handleExpandClick}
              />
            </Grid>
          ))}
        </Grid>
        <Copyright sx={{ pt: 4 }} />
      </Container>
    </Box>
  );
}
